import { render, staticRenderFns } from "./crumb.vue?vue&type=template&id=00c0b9a8"
import script from "./crumb.vue?vue&type=script&lang=js"
export * from "./crumb.vue?vue&type=script&lang=js"
import style0 from "./crumb.vue?vue&type=style&index=0&id=00c0b9a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports